module.exports = __webpack_public_path__ + "img/dots.3dbe81a8.svg";